export const REDIRECT_ACTION_BUTTONS_TO_LEGACY_PORTAL = 'myevRefreshLegacyRedirect';

export const USE_EMBEDDED_EXPLORER = 'myevEmbeddedExplorer';

export const ENABLE_GEOMNI_ESX_ADDON_LOGIC = 'enableGeomniEsxAddonLogic';

export const SUBSCRIPTION_DASHBOARD = 'subscriptionDashboard';

export const UNIFIED_SKU_SLA_AREA_LAND_USE = 'unifiedSkuSlaAreaLandUse';

export const ESX_FOR_UPGRADE = 'esXforUpgrade';

export const ENABLE_MULTI_PAYMENT_METHODS = 'enableMultiPaymentMethods'; // #genai

// #genai Gate Order History Sitemap Approval button.
// LD key: MYEV_SITEMAP_AUTOMATION → host passes camelCase myevSitemapAutomation into MyEV Redux.
export const MYEV_SITEMAP_AUTOMATION = 'myevSitemapAutomation';
